<template>
  <b-form @submit.prevent="validateBeforeSubmit">
    <!-- ROW 1 -->
    <b-row class="my-1">
      <!-- SERVICE TYPE -->
      <b-col md="6">
        <b-form-group
          id="serviceType"
          :label="$t('servicios.formularioExpedicion.tipoServicio')"
          label-for="serviceType"
        >
          <b-row>
            <b-col md="10" class="pr-0">
              <b-select
                v-model="servicioSeleccionado"
                :readonly="!puedoEditar"
                @input="actualizarServicio"
              >
                <option
                  v-for="TipoServicio in servicesTypes"
                  :value="TipoServicio"
                  :key="TipoServicio.CODIGO"
                  >{{ TipoServicio.NOMBRE }}</option
                >
              </b-select>
            </b-col>
            <b-col md="2" class="pl-0">
              <b-btn @click="cargarTiposServicio">{{
                $t("servicios.formularioExpedicion.refrescar")
              }}</b-btn>
            </b-col>
          </b-row>
        </b-form-group>
      </b-col>
      <b-col>
        <p>{{ servicioDescripcion }}</p>
      </b-col>

      <b-col>
        <b-col>
          <!-- Entrega en sabado -->
          <b-form-checkbox
            id="saturdayDelivery"
            class="my-1"
            v-model="servicio.EntregaSabado"
            @input="$v.servicio.$touch"
            value="true"
            :disabled="!puedoEditar || !esViernes"
            unchecked-value="false"
            >{{
              $t("servicios.formularioExpedicion.entregaSabado")
            }}</b-form-checkbox
          >
          <!-- Acuse recibo -->
          <b-form-checkbox
            id="acuseRecibo"
            class="my-1"
            v-model="servicio.AcuseRecibo"
            @input="$v.servicio.$touch"
            value="true"
            :disabled="!puedoEditar"
            unchecked-value="false"
            >{{
              $t("servicios.formularioExpedicion.acuseRecibo")
            }}</b-form-checkbox
          >
        </b-col>
        <b-col>
          <!-- Retorno -->
          <b-form-checkbox
            id="returned"
            class="my-1"
            v-model="servicio.Retorno"
            @input="$v.servicio.$touch"
            :disabled="!puedoEditar"
            value="true"
            unchecked-value="false"
            >{{ $t("servicios.formularioExpedicion.retorno") }}</b-form-checkbox
          >
          <b-form-checkbox
            id="managment"
            class="my-1"
            v-model="servicio.Gestion"
            @input="$v.servicio.$touch"
            value="true"
            :disabled="!puedoEditar"
            unchecked-value="false"
            >{{ $t("servicios.formularioExpedicion.gestion") }}</b-form-checkbox
          >
          <b-form-checkbox
            class="my-1"
            v-model="servicio.AvisoEmailRemitente"
            :disabled="!puedoEditar"
            >{{
              $t("servicios.formularioExpedicion.envioEmailRemitente")
            }}</b-form-checkbox
          >
          <b-form-checkbox
            class="my-1"
            v-model="servicio.AvisoEmailDestino"
            :disabled="!puedoEditar"
            >{{
              $t("servicios.formularioExpedicion.envioEmailDestino")
            }}</b-form-checkbox
          >
        </b-col>
      </b-col>

      <!-- Horas Recogidas -->
      <b-col md="2">
        <b-form-group
          center
          id="time"
          :label="$t('servicios.formularioExpedicion.recogidaHoraInicial')"
          label-for="time"
        >
          <b-form-input
            autocomplete="off"
            id="time"
            type="time"
            v-model="servicio.RecogidaHoraInicial"
            :disabled="!puedoEditar"
          ></b-form-input>
        </b-form-group>
        <b-form-group
          center
          id="time"
          :label="$t('servicios.formularioExpedicion.recogidaHoraFinal')"
          label-for="time"
        >
          <b-form-input
            autocomplete="off"
            id="time"
            type="time"
            v-model="servicio.RecogidaHoraFinal"
            :disabled="!puedoEditar"
          ></b-form-input>
        </b-form-group>
      </b-col>
      <!-- Fin Horas Recogidas -->

      <b-col v-if="false">
        <b-form-group
          center
          id="deliveryDate"
          label="Fecha prevista entrega"
          label-for="deliveryDate"
        >
          <b-form-input
            autocomplete="off"
            id="deliveryDate"
            type="date"
            v-model="servicio.FechaPrevista"
            @input="revisarFecha"
            :readonly="!puedoEditar"
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col v-if="false">
        <b-form-group
          center
          id="EntregaNif"
          label="EntregaNif"
          label-for="EntregaNif"
          prepend="favorite"
        >
          <b-form-input
            autocomplete="on"
            id="nif"
            name="Cardholder"
            v-model="servicio.EntregaNif"
            :readonly="!puedoEditar"
          ></b-form-input>
          <b-form-invalid-feedback id="NifNumber" v-if="$v.servicio.$dirty"
            >Este campo tiene que tener 9 digitos</b-form-invalid-feedback
          >
        </b-form-group>
      </b-col>

      <b-col v-if="false">
        <b-form-group
          center
          id="RecogidaNif"
          label="RecogidaNif"
          label-for="RecogidaNif"
          prepend="favorite"
        >
          <b-form-input
            autocomplete="on"
            id="nif"
            name="Cardholder"
            v-model="servicio.RecogidaNif"
            :readonly="!puedoEditar"
          ></b-form-input>
          <b-form-invalid-feedback id="NifNumber" v-if="$v.servicio.$dirty"
            >Este campo tiene que tener 9 digitos</b-form-invalid-feedback
          >
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <PackageList
        :puedoEditar="puedoEditar"
        :Bultos="servicio.Bultos"
      ></PackageList>
    </b-row>

    <!-- ROW 4 -->
    <b-row>
      <b-row class="ml-2">
        <b-col>
        <!-- Importe valor asegurado -->
          <b-form-group
            id="insuredAmoun"
            :label="$t('servicios.formularioExpedicion.importeValorAsegurado')"
            label-for="insuredAmount"
          >
            <currency-input
              :min="0"
              v-model="servicio.ImporteValor"
              class="demo__currency-input"
              :readonly="!puedoEditar"
            />
            <v-chip v-if="servicio.ImporteValor > 0">{{
              $t("servicios.formularioExpedicion.aseguradoTodoRiesgo")
            }}</v-chip>
          </b-form-group>
        </b-col>

        <b-col md="4" v-if="false">
          <!-- Tipo de valor asegurado -->
          <b-form-group
            id="insuredAmountType"
            label="Tipo valor asegurado"
            label-for="insuredAmountType"
            v-if="false"
          >
            <b-form-input
              autocomplete="off"
              id="insuredAmountType"
              v-model="servicio.ImporteValorType"
              @input="$v.servicio.$touch"
              :readonly="!puedoEditar"
            ></b-form-input>
          </b-form-group>
        </b-col>

        <b-col>
          <!-- IMPORTE REEMBOLSO -->
          <b-form-group
            center
            id="refundAmount"
            :label="$t('servicios.formularioExpedicion.importeReembolso')"
            label-for="refundAmount"
          >
            <currency-input
              :min="0"
              v-model="servicio.ImporteReembolso"
              class="demo__currency-input"
              :readonly="!puedoEditar"
            />
          </b-form-group>
        </b-col>

        <b-col v-if="false">
          <!-- IMPORTE cobro cuenta -->
          <b-form-group
            center
            id="accountChargedAmount"
            label="Importe cobro cuenta"
            label-for="accountChargedAmount"
          >
            <b-form-input
              autocomplete="off"
              type="number"
              value="0"
              min="0"
              max="60"
              v-model="servicio.ImporteCobroACuenta"
              @input="$v.servicio.$touch"
              :readonly="!puedoEditar"
            ></b-form-input>
          </b-form-group>
        </b-col>

        <b-col>
          <!-- IMPORTE DEBIDO -->
          <b-form-group
            center
            id="refundAmount"
            label=" "
            label-for="refundAmount"
          >
            <b-form-checkbox
              v-model="servicio.ImporteDebido"
              @input="$v.servicio.$touch"
              :disabled="!puedoEditar"
              unchecked-value="false"
              class="pt-2"
              >{{
                $t("servicios.formularioExpedicion.porteDebido")
              }}</b-form-checkbox
            >
          </b-form-group>
        </b-col>
      </b-row>

      <b-col v-if="PuedoCalcularPrecio">
        <b-row class="text-right">
          <b-col class="text-right">
            <h4 class="mt-2" style="display: inline-block; border: 1px solid black; padding: 8px">{{precio}}</h4>
            <v-btn type="button" :disabled="!servicioSeleccionado || servicioSeleccionado.CODIGO === undefined" class="primary" @click="cargarPrecio">{{ $t("servicios.formularioExpedicion.cargarPrecio") }}</v-btn>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <!-- ROW 7 -->
    <b-row v-if="false">
      <!-- PESO -->
      <b-col>
        <b-form-group id="weight" label="Peso" label-for="weight" class="my-1">
          <b-form-input
            autocomplete="off"
            type="number"
            value="0"
            v-model.number="servicio.PesoTotal"
            @input="$v.servicio.$touch"
            disabled
          ></b-form-input>
        </b-form-group>
      </b-col>
      <!-- BULTOS -->
      <b-col></b-col>
      <b-col>
        <b-form-group
          id="package"
          label="Num Bultos"
          label-for="package"
          class="my-1"
        >
          <b-input-group>
            <b-form-input
              autocomplete="off"
              id="package"
              type="number"
              value="0"
              v-model.number="servicio.NumBultos"
              @input="$v.servicio.$touch"
              disabled
            ></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { mapActions, mapState, mapGetters } from "vuex";
import PackageList from "./ExpeditionPackagesV2";
import { EventBus } from "./../../event-bus.js";
import Vue from 'vue'
import { parse } from 'query-string';

export default {
  mixins: [validationMixin],
  created: function() {
    EventBus.$on("cargarTiposServicio", blank => {
      this.cargarTiposServicio();
    });
    EventBus.$on("cargarPrecio", blank => {
      this.cargarPrecio();
    });
  },
  mounted() {
    if (!this.nuevoServicio) {
      let servicio = {
        NOMBRE: this.servicio.TipoServicio.name,
        CODIGO: this.servicio.TipoServicio.code
      };
      this.servicesTypes.push(servicio);
      this.servicio.TipoServicio = servicio;
      this.servicioSeleccionado = servicio;
    } else {
      this.servicio.TipoServicio = this.selectedServiceType;
    }
    this.servicio.AvisoEmailRemitente = this.Auth.Usuario.DOMICILIO.AvisoEmailRemitente;
    this.servicio.AvisoEmailDestino = this.Auth.Usuario.DOMICILIO.AvisoEmailDestino;
  },
  props: {
    servicio: {
      type: Object,
      required: true
    },
    nuevoServicio: {
      type: Boolean,
      required: false,
      default: false
    },
    puedoEditar: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  components: {
    PackageList
  },
  data() {
    return {
      esViernes: false,
      servicioDescripcion: "",
      servicesTypes: [],
      precio: 0,
      servicioSeleccionado: null,
      stringPackage: "Ver bultos",
      activePackage: false,
      selectedServiceType: {
        code: null,
        name: ""
      }
    };
  },
  showModal: false,
  validations: {
    servicio: {}
  },
  methods: {
    revisarFecha() {
      var d = new Date(this.servicio.Fecha);
      this.esViernes = d.getDay() === 5;
    },
    async actualizarServicio() {
      this.servicio.AvisoEmailRemitente = this.Auth.Usuario.DOMICILIO.AvisoEmailRemitente;
      this.servicio.AvisoEmailDestino = this.Auth.Usuario.DOMICILIO.AvisoEmailDestino;
      //{{Auth.Usuario.DOMICILIO.AvisoEmailDestino}}
      //{{Auth.Usuario.DOMICILIO.AvisoEmailRemitente}}
      this.servicio.TipoServicio.code = this.servicioSeleccionado.CODIGO;
      this.servicio.TipoServicio.name = this.servicioSeleccionado.NOMBRE;
      this.$emit("checkTipoServicio");

      let res = await fetch(
        this.$apiRoute +
          "tipoServicio/" +
          this.servicioSeleccionado.CODIGO +
          "/descripcion",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + window.localStorage.getItem("_token")
          }
        }
      );

      if (res.ok) {
        let respuesta = await res.json();
        if (respuesta.length > 0)
          this.servicioDescripcion = respuesta[0].DESCRIPCION; //TODO ERROR
      }
    },
    validateBeforeSubmit() {
      this.$emit("processExpedition", this.expedition);
    },
    ...mapActions("servicesTypes", ["fetchServicesTypes"],),
    async cargarTiposServicio() {
      let filtro = {
        PaisOrigen: this.servicio.Remitente.Pais,
        CodigoPostalOrigen: this.servicio.Remitente.CodigoPostal,
        PaisDestino: this.servicio.Destinatario.Pais,
        CodigoPostalDestino: this.servicio.Destinatario.CodigoPostal
      };

      let tiposServicios = await this.fetchServicesTypes(filtro);
      //console.log("DATOS: " + JSON.stringify(tiposServicios));
      this.servicesTypes = Array.isArray(tiposServicios) ? tiposServicios : [];
    },
    async cargarPrecio() {
      this.precio = "Calculando...";

      try {
        const response = await fetch(this.$apiRoute + "expediciones/precio", {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + window.localStorage.getItem("_token")
          },
          body: JSON.stringify(this.servicio)
        });

        const data = await response.json();
        this.precio = data;

        if (!response.ok) {
          this.precio = data && data.Message ? data.Message : "No se pudo calcular precio";
          this.$toast(this.precio, { color: "red" });
          return;
        }

        if (typeof(this.precio) === "string") {
          this.precio = this.precio.replace(/,/g, '.');
          if (this.precio === "0") this.precio = "No se ha podido encontrar un precio para los datos solicitados."
          else this.precio = "El precio es de " + this.precio + " €"
        } else if (typeof(this.precio) === "object" && this.precio.Message) {
          this.precio = this.precio.Message;
        }
        if (this.precio === "NaN") this.precio = 0;
      } catch (error) {
        this.precio = "No se pudo calcular precio";
        this.$toast(error.message || this.precio, { color: "red" });
      }
    }
  },
  computed: {
    ...mapState(["Auth"]),
    ...mapGetters({
      PuedoCalcularPrecio: "Auth/PuedoCalcularPrecio",
    }),
  }
};
</script>

<style>
.center {
  width: 500px;
  margin: 24px auto 44px auto !important;
}
.demo__currency-input {
  font-family: "Roboto Condensed", sans-serif;
  font-size: 14px;
  padding: 8px 12px;
  max-width: 100%;
  box-sizing: border-box;
  border: 1px solid #e2e4e6;
  border-radius: 4px;
}
</style>
